import {Component} from '@angular/core';
import {NavController, NavParams, ModalController, AlertController} from 'ionic-angular';

import {Location} from '../../models/location';
import {ThinningDataset} from "../../models/thinning-dataset";

import {LocationEditPage} from '../location-edit/location-edit';
import {LocationIrrigationPage} from '../location-irrigation/location-irrigation';
import {LocationCarbohydratePage} from '../location-carbohydrate/location-carbohydrate';

import {ThinningDatasetEditPage} from '../thinning-dataset-edit/thinning-dataset-edit';
import {ThinningDatasetDetailPage} from '../thinning-dataset-detail/thinning-dataset-detail';

import {Data} from '../../providers/providers';
import * as _ from 'lodash';
import {SprayRecordListPage} from "../spray-record-list/spray-record-list";
import {AboutLocationDetailsPage} from "../about-location-details/about-location-details";
import {LocationIrrigationRecordListPage} from "../location-irrigation-record-list/location-irrigation-record-list";

@Component({
    selector: 'page-location-detail',
    templateUrl: 'location-detail.html'
})
export class LocationDetailPage {

    location: Location;

    constructor(public navCtrl: NavController,
                public modalCtrl: ModalController,
                private alertCtrl: AlertController,
                public navParams: NavParams,
                public data: Data) {
        this.location = this.navParams.get('location');
    }

    ngAfterViewInit() {
        if (this.data.hasInvalidWeatherStationId(this.location)) {
            let alert = this.alertCtrl.create({
                title: 'Invalid Weather Station',
                message: 'The weather station selected for this Location is no longer valid, due to changes to the database - please edit the Location and re-select the appropriate station.',
                buttons: [
                    {
                        text: 'OK',
                        role: 'cancel',
                        handler: () => {
                        }
                    },
                ]
            });
            alert.present();
        }
    }

    editLocation() {
        let editModal = this.modalCtrl.create(LocationEditPage, {location: this.location});

        editModal.onDidDismiss(location => {
            // location is not set if user cancelled modal
            if (location) {
                this.data.updateLocation(location);
                // refresh location display
                this.location = location;
            }
        });
        editModal.present();
    }

    deleteLocation(location: Location) {
        let alert = this.alertCtrl.create({
            title: 'Confirm deletion',
            message: 'Permanently delete this Location?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: 'Delete',
                    handler: () => {
                        this.data.removeLocation(this.location);
                        // return to location list
                        this.navCtrl.pop();
                    }
                }
            ]
        });
        alert.present();
    }

    cloneLocation() {
        let newLocation = _.clone(this.location);

        // increment year and orchard_age for new location
        newLocation.year = this.location.year + 1;
        const age = this.location.orchard_age;
        if (age != 'mature' && _.toNumber(age) <= 3) {
            newLocation.orchard_age = age + 1;
        } else {
            newLocation.orchard_age = 'mature';
        }

        let editModal = this.modalCtrl.create(LocationEditPage, {location: newLocation});

        editModal.onDidDismiss(location => {
            // NB: not cloning existing thinning_dataset...
            this.data.addLocation(location);
            // return to location list
            this.navCtrl.pop();
        });
        editModal.present();
    }

    openSprayRecords() {
        this.navCtrl.push(SprayRecordListPage, {
            location: this.location
        });
    }

    openThinningModel() {
        // if location doesn't have a thinning_dataset yet, open create modal; otherwise show dataset detail

        const existingDataset = this.data.getThinningDatasetDoc(this.location);
        let firstUpdate = true; // don't do the following every time the value changes

        existingDataset.valueChanges().subscribe((val: ThinningDataset) => {
            if (firstUpdate) {
                firstUpdate = false;

                if (!val || val.tree_count === undefined) {
                    const dataset: ThinningDataset = new ThinningDataset({
                        id: this.location.id,
                        tree_count: 5,
                        cluster_count: 15,
                        flower_count: 5
                    });
                    let addModal = this.modalCtrl.create(ThinningDatasetEditPage, {dataset: dataset});
                    addModal.onDidDismiss(dataset => {
                        if (dataset) {
                            this.data.addThinningDataset(dataset);
                            this.navCtrl.push(ThinningDatasetDetailPage, {
                                location: this.location,
                                dataset: dataset
                            });
                        }
                    })
                    addModal.present();
                } else {
                    this.navCtrl.push(ThinningDatasetDetailPage, {
                        location: this.location,
                        dataset: val
                    });
                }
            }
        });
    }

    openIrrigationModel() {
        this.navCtrl.push(LocationIrrigationPage, {
            location: this.location
        });
    }

    openIrrigationRecords() {
        this.navCtrl.push(LocationIrrigationRecordListPage, {
            location: this.location
        });
    }

    openCarbohydrateModel() {
        this.navCtrl.push(LocationCarbohydratePage, {
            location: this.location
        });
    }

    openAbout() {
        this.navCtrl.push(AboutLocationDetailsPage, {});
    }

}



// WEBPACK FOOTER //
// ./src/pages/location-detail/location-detail.ts